define [], () ->
  name: 'verifications', url: '^/verifications/', public: true
  template: require("./verifications.jade")
  params:
    context: 'landlord'
    vendor: 'experian'
  children: [
    name: 'disclaimer', url: 'disclaimer/', public: false
    template: require("./disclaimer/disclaimer.jade")
    controller: require("./disclaimer/disclaimer.coffee")
  ,
    name: 'personal_info', url: 'personal_info/', public: false
    template: require("./personal_info/personal_info.jade")
    controller: require("./personal_info/personal_info.coffee")
  ,
    name: 'questions', url: 'questions/', public: false
    template: require("./questions/questions.jade")
    controller: require("./questions/questions.coffee")
    params:
      landlord_data: {}
      questions: []
  ,
    name: 'verify_success', url: 'success/', public: false
    template: require("./success/success.jade")
    controller: require("./success/success.coffee")
  ,
    name: 'verify_fail', url: 'fail/', public: false
    template: require("./fail/fail.jade")
    controller: require("./fail/fail.coffee")
  ]


// WEBPACK FOOTER //
// ./components/verifications/routes.coffee